<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        //- Top nav
        v-card-title.px-5
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ $t('set_bundle_items') }}
        
        v-divider.mb-4.basic300

        v-card-text.pa-0
          //- Bundle item slot settings
          div.d-flex.flex-column.align-center.py-4
            p.s1 {{ $t('how_many_items') }}
            div.d-flex.align-center.mb-2
              v-btn.my-auto(icon small :disabled="disableMinus" @click="slots.pop()")
                v-icon(color="black" size="21") mdi-minus-circle
              v-spacer
              div.quantity-box.text-center.mx-3
                span.body-1 {{ slotCount }}
              v-spacer
              v-btn.my-auto(icon small @click="addSlot")
                v-icon(color="black" size="21") mdi-plus-circle
            div.p2.basic600--text {{ $t('buyers_must_choose', { text: slotCount }) }}

          v-divider.my-4.basic300

          //- Assign product
          div.px-4.pt-4.py-10
            //- Title
            div.mb-4
              div.s1 {{ $t('assign_products') }}
              div.p1.basic700--text {{ $t('assign_products_text') }}
            //- Each slot
            div.mb-4(v-for="(slot, slotIndex) in slots")
              div.d-flex
                div.s2.basic700--text {{ $t('item') }} {{ slotIndex + 1 }}
                v-spacer
                div.d-flex
                  v-btn.mr-3(v-if="slots.length > 2" icon small @click="selectedSlotIndex = slotIndex; openConfirmDeleteDialog = true")
                    eva-icon(name="trash-2-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary500")
                  v-btn.mr-1(v-if="slot.group.products.length > 0" icon small @click="selectedSlot = slot; selectedSlotIndex = slotIndex; openAssignProductsBundleDialog = true")
                    v-icon(color="primary") mdi-plus
              div.my-1.d-flex.scrolling-wrapper(v-if="slot.group.products.length > 0")
                div.mr-1(v-for="product in slot.group.products" :key="product.id" @click="selectedSlot = slot; selectedSlotIndex = slotIndex; openEditProductsBundleDialog = true")
                  v-card.d-flex.justify-center.align-center(outlined style="border: 1px solid" :style="$vuetify.breakpoint.xs ? 'width: 70px' : 'width: 95px'" :height="$vuetify.breakpoint.xs ? '70px' : '95px'")
                    v-img(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" aspect-ratio="1")
              template(v-else)
                v-card.my-1.d-flex.justify-center.align-center(outlined style="border: 1px solid" :style="$vuetify.breakpoint.xs ? 'width: 70px' : 'width: 95px'" :height="$vuetify.breakpoint.xs ? '70px' : '95px'" @click="selectedSlot = slot; selectedSlotIndex = slotIndex; openAssignProductsBundleDialog = true")
                  v-card-text.text-center
                    v-icon(color="black") mdi-plus
              div.mt-2.c1.basic600--text {{ $t('buyers_can_choose_from', { count: `${productCount(slot)} ${productCount(slot) > 1 ? 'products' : 'product'}`, index: slotIndex + 1 }) }}
              v-divider.mt-4.basic400(v-if="slotIndex < slots.length-1")
        
        //- Actions
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-medium.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32 @click="save" dark)
            .button-AA-medium.basic100--text {{ $t('save') }}

    .dialogs
      assign-products-bundle(v-if="openAssignProductsBundleDialog" :open.sync="openAssignProductsBundleDialog" :excludeProductIds="excludeProductIds" @updateData="handleAddProducts")
      edit-products-bundle(v-if="openEditProductsBundleDialog" :open.sync="openEditProductsBundleDialog" :parentSlot="selectedSlot" @updateData="handleUpdateProducts" :slotNumber="selectedSlotIndex+1")
      //- Confirm delete
      y-dialog(v-model='openConfirmDeleteDialog', persistent max-width="320")
        v-card
          v-card-text.p1.primary500--text.pa-6
            div(v-html="$t('delete_item_confirmation', { text: selectedSlotIndex + 1 })")
          v-card-actions
            v-spacer
            v-btn(color="white", text @click="openConfirmDeleteDialog = false")
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color="danger500" depressed height=32 @click="removeSlot" dark)
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import clone from 'just-clone'
import { mapActions } from 'vuex'
import AssignProductsBundle from '@/components/offers/dialogs/bundles/AssignProductsBundle.vue'
import EditProductsBundle from '@/components/offers/dialogs/bundles/EditProductsBundle.vue'

export default {
  name: 'SetBundleItems',
  components: {
    AssignProductsBundle,
    EditProductsBundle
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    parentSlots: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      openAssignProductsBundleDialog: false,
      openEditProductsBundleDialog: false,
      openConfirmDeleteDialog: false,
      slots: [],
      selectedSlot: null,
      selectedSlotIndex: null,
      emptySlot: {
        id: null,
        group: {
          id: null,
          type: 'bundle',
          products: []
        }
      }
    }
  },
  mounted() {
    this.slots = clone(this.parentSlots)
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(val) {
        this.$emit('update:open', val)
      }
    },
    slotCount() {
      return this.slots.length
    },
    excludeProductIds() {
      if (!this.selectedSlot) {
        return ''
      }
      return this.selectedSlot.group.products.map(product => product.id).join(',')
    },
    lastSlotIsEmpty() {
      if (this.slots.length > 0) {
        return this.slots[this.slots.length-1].group.products.length === 0
      } else {
        return false
      }
    },
    hasEmptySlot() {
      return this.slots.some(slot => slot.group.products.length === 0)
    },
    disableMinus() {
      if (this.slots.length === 2) {
        return true
      }
      return !this.lastSlotIsEmpty
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    addSlot() {
      this.slots.push(clone(this.emptySlot))
    },
    removeSlot() {
      this.slots.splice(this.selectedSlotIndex, 1)
      this.openConfirmDeleteDialog = false
    },
    productCount(slot) {
      return slot.group.products.length
    },
    handleAddProducts(newValue) {
      const currentProducts = [...this.slots[this.selectedSlotIndex].group.products]
      this.slots[this.selectedSlotIndex].group.products = currentProducts.concat(newValue)
    },
    handleUpdateProducts(newValue) {
      this.slots[this.selectedSlotIndex].group.products = clone(newValue)
    },
    save() {
      if (this.hasEmptySlot) {
        this.showMessage(['error', this.$t('error_message.please_fill_all_items')])
        return
      }
      this.$emit('updateSlot', this.slots)
      this.showModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
.quantity-box {
  border: 1px solid rgba(193, 193, 193, 1);
  border-radius: 6px;
  height: 24px;
  width: 46px;
  color: black;
}
.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>

<i18n>
{
  "en": {
    "set_bundle_items": "Set bundle items",
    "how_many_items": "How many items are in this bundle?",
    "buyers_must_choose": "Buyers must choose {text} items to get this offer",
    "assign_products": "Assign products",
    "assign_products_text": "Select the group of products buyers can choose from for each item.",
    "item": "Item",
    "buyers_can_choose_from": "Buyers can choose from {count} for item {index}",
    "delete_item_confirmation": "Are you sure you want to <b> delete Item {text}</b> from this bundle?"
  },
  "ms": {
  },
  "id": {
    "set_bundle_items": "Atur/Tetapkan item Bundle/paket",
    "how_many_items": "Berapa banyak item dalam Bundle/paket ini??",
    "buyers_must_choose": "Pembeli harus memilih {number} item untuk mendapatkan penawaran ini",
    "assign_products": "Tetapkan/Tentukan produk",
    "assign_products_text": "Pilih kategori produk yang dapat dipilih pembeli untuk setiap item.",
    "item": "Item",
    "buyers_can_choose_from": "Pembeli dapat memilih dari {count} produk untuk item {index}",
    "delete_item_confirmation": "Apakah kamu yakin ingin <b> menghapus Item {text}</b> dari Bundle ini?"
  }
}
</i18n>